import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
  padding: var(--space-600);
  border-radius: var(--radius-brand);
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
`;
export const Header = styled.div `
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  margin-bottom: var(--space-500);
  display: flex;
  align-items: center;
  gap: var(--space-200);
`;
export const StatusList = styled.div `
  /* Container for status items */
`;
export const StatusItem = styled.div `
  margin-bottom: var(--space-400);
`;
export const StatusLabel = styled.div `
  margin-bottom: var(--space-200);
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-medium);
`;
export const ProgressText = styled.div `
  margin-top: var(--space-100);
  font-size: var(--font-size-200);
  color: var(--text-secondary);
`;
export const PendingContainer = styled.div `
  display: flex;
  align-items: center;
  gap: var(--space-100);
  margin-top: var(--space-100);
  font-size: var(--font-size-200);
  color: var(--text-secondary);
`;
